import React, { Component } from "react";
import * as s from "./DocumentFilesDropdown.module.scss";
import { P, Tag } from "src/views/shared/components";
import { Icons } from "src/libs/assets";
import { tx } from "src/libs/i18n";
import FileSaver from "file-saver";
import { UIStore } from "src/stores";
import { inject, observer } from "mobx-react";

interface Props {
  title: string;
  documents: any;
  forceOpen?: boolean;
  uiStore?: UIStore;
}

interface State {
  open: boolean;
}

@inject("uiStore")
@observer
export class DocumentFilesDropdown extends Component<Props, State> {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
    };
  }

  componentDidMount = () => {
    if (this.props.forceOpen) this.setState({ open: true });
  };

  toggleDropdown = () => {
    this.setState({
      open: !this.state.open,
    });
  };

  renderDocumentRow = (document, i) => {
    const { isDesktop } = this.props.uiStore;
    let title = "";
    let link = "";
    let icon = "";
    let download = false;
    switch (true) {
      case !!document?.documentFile?.link:
      case document?.type == "file":
        title = document?.documentFile?.title;
        link = true
          ? `/pdf/${/[^/]*$/.exec(document?.documentFile?.mediaItemUrl)[0]}/`
          : document?.documentFile?.mediaItemUrl;
        if (document?.documentFile?.mimeType !== "application/pdf") {
          // download = true;
        }
        icon = Icons.file_text_small;
        break;

      default:
        title = document?.documentLinkTitle;
        link = document?.documentLink;
        icon = Icons.externalLink_small;
        break;
    }
    const documentHasFile = document?.type === "file";

    if (!title) return;
    return (
      <div className={s.dropdownItem} key={i}>
        <img src={icon} alt="text-file" className={s.textFileIcon} />
        <div className={s.documentInformation}>
          {documentHasFile || document.documentLink ? (
            !download ? (
              <a href={link} target="_blank">
                <P className={s.documentTitle}>{title}</P>
              </a>
            ) : (
              <a
                href={document?.documentFile?.mediaItemUrl}
                download
                onClick={e => {
                  e.preventDefault();
                  const split = document?.documentFile?.mediaItemUrl
                    .split("?")[0]
                    .split("/");
                  FileSaver.saveAs(
                    document?.documentFile?.mediaItemUrl,
                    split[split.length - 1]
                  );
                }}
              >
                <P className={s.documentTitle}>{title}</P>
              </a>
            )
          ) : (
            <a
              href={document?.documentFile?.mediaItemUrl}
              download
              onClick={e => {
                e.preventDefault();
                const split = document?.documentFile?.mediaItemUrl
                  .split("?")[0]
                  .split("/");
                FileSaver.saveAs(
                  document?.documentFile?.mediaItemUrl,
                  split[split.length - 1]
                );
              }}
            >
              <P className={s.documentTitle}>{title}</P>
            </a>
          )}
        </div>
        {documentHasFile && (
          <a href={link} target="_blank">
            <img
              src={Icons.externalLink_small}
              alt="external-link-icon"
              className={s.externalLinkIcon}
            />
          </a>
        )}
        {document.type === "file" && document?.documentFile?.mediaItemUrl && (
          <a
            href={document.documentFile.mediaItemUrl}
            download
            onClick={e => {
              e.preventDefault();
              const split = document.documentFile.mediaItemUrl
                .split("?")[0]
                .split("/");
              FileSaver.saveAs(
                document.documentFile.mediaItemUrl,
                split[split.length - 1]
              );
            }}
          >
            <img
              src={Icons.download_small}
              alt="download-icon"
              className={s.downloadIcon}
            />
          </a>
        )}
      </div>
    );
  };
  render() {
    const { title, documents } = this.props;
    const { open } = this.state;

    console.log(documents);
    console.log(documents);
    console.log(documents);

    const { isDesktop } = this.props.uiStore;
    const dropdownItemsClasses = [s.dropdownItems];
    let icon = Icons.chevronDown_large;

    if (open) {
      dropdownItemsClasses.push(s.open);
      icon = Icons.chevronUp_large;
    }
    const numberOfDocuments =
      documents &&
      documents.filter(
        document => document?.documentFile?.title || document?.documentLinkTitle
      ).length;
    return (
      <div className={s.documentFilesDropdown}>
        <div className={s.dropdownHeader} onClick={this.toggleDropdown}>
          <img
            src={icon}
            alt="dropdown-chevron"
            className={s.dropdownChevronIcon}
          />
          <P medium className={s.dropdownTitle}>
            {title}
          </P>
          <Tag
            size="small"
            title={tx("document.documentsDropdownCount", {
              number: documents && numberOfDocuments,
            })}
            rounded
            disabled
          />
        </div>
        <div className={dropdownItemsClasses.join(" ")}>
          {documents &&
            documents.map((document, i) => this.renderDocumentRow(document, i))}
        </div>
      </div>
    );
  }
}
